import { Injectable, signal } from '@angular/core';

const LOCK_STATE_KEY = 'ews_lock_state';

@Injectable({
  providedIn: 'root'
})
export class LockScreenService {
  private readonly _isLocked = signal(this.loadLockState());
  
  readonly isLocked = this._isLocked.asReadonly();

  /**
   * Load lock state from localStorage
   */
  private loadLockState(): boolean {
    try {
      const stored = localStorage.getItem(LOCK_STATE_KEY);
      return stored === 'true';
    } catch {
      return false;
    }
  }

  /**
   * Save lock state to localStorage
   */
  private saveLockState(isLocked: boolean): void {
    try {
      localStorage.setItem(LOCK_STATE_KEY, String(isLocked));
    } catch {
      console.error('Failed to save lock state');
    }
  }

  lock(): void {
    this._isLocked.set(true);
    this.saveLockState(true);
  }

  unlock(): void {
    this._isLocked.set(false);
    this.saveLockState(false);
  }
}

